document.addEventListener('DOMContentLoaded', () => {
    const navigation = document.querySelector('.ce_rsce_navigation');

    if (!navigation) {
        return;
    }

    const menuButton = navigation.querySelector('.menuButton');
    const mobileNav = navigation.querySelector('.mobile');
    const desktopNav = navigation.querySelector('.desktop .mod_navigation.block');
    const desktopBreakpoint = window.matchMedia('(min-width: 768px)');

    const setMobileMenuState = isOpen => {
        if (!menuButton || !mobileNav) {
            return;
        }

        menuButton.classList.toggle('active', isOpen);
        mobileNav.classList.toggle('active', isOpen);
        menuButton.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
        document.body.classList.toggle('mobile-nav-open', isOpen);
    };

    if (menuButton && mobileNav) {
        menuButton.addEventListener('click', () => {
            setMobileMenuState(!mobileNav.classList.contains('active'));
        });
    }

    const closeNestedMenus = scope => {
        scope.querySelectorAll('li.submenu.open').forEach(item => {
            item.classList.remove('open');
        });

        scope.querySelectorAll('.submenu-toggle[aria-expanded="true"]').forEach(toggle => {
            toggle.setAttribute('aria-expanded', 'false');
        });
    };

    if (mobileNav) {
        mobileNav.querySelectorAll('li.submenu').forEach(menuItem => {
            const toggle = menuItem.querySelector(':scope > .submenu-toggle');
            const submenu = menuItem.querySelector(':scope > .level_2, :scope > .level_3');

            if (!toggle || !submenu) {
                return;
            }

            if (menuItem.classList.contains('trail') || menuItem.classList.contains('active')) {
                menuItem.classList.add('open');
                toggle.setAttribute('aria-expanded', 'true');
            }

            toggle.addEventListener('click', event => {
                event.preventDefault();
                event.stopPropagation();

                const isOpen = menuItem.classList.contains('open');
                const siblingItems = Array.from(menuItem.parentElement.children).filter(item => item !== menuItem && item.classList.contains('submenu'));

                siblingItems.forEach(item => {
                    item.classList.remove('open');
                    const siblingToggle = item.querySelector(':scope > .submenu-toggle');
                    if (siblingToggle) {
                        siblingToggle.setAttribute('aria-expanded', 'false');
                    }
                });

                menuItem.classList.toggle('open', !isOpen);
                toggle.setAttribute('aria-expanded', !isOpen ? 'true' : 'false');
            });
        });

        mobileNav.querySelectorAll('a').forEach(link => {
            link.addEventListener('click', () => {
                if (!desktopBreakpoint.matches) {
                    setMobileMenuState(false);
                    closeNestedMenus(mobileNav);
                }
            });
        });
    }

    if (desktopBreakpoint.matches) {
        setMobileMenuState(false);
    }

    desktopBreakpoint.addEventListener('change', event => {
        if (event.matches) {
            setMobileMenuState(false);
            if (mobileNav) {
                closeNestedMenus(mobileNav);
            }
        }
    });

    if (desktopNav) {
        const hideDelay = 180;

        const bindHoverMenu = (menuItem, submenuSelector, hoverClass = 'submenu-hover') => {
            const submenu = menuItem.querySelector(`:scope > ${submenuSelector}`);

            if (!submenu) {
                return;
            }

            let hideTimer = null;

            const openMenu = () => {
                window.clearTimeout(hideTimer);
                menuItem.classList.add(hoverClass);
            };

            const closeMenu = () => {
                hideTimer = window.setTimeout(() => {
                    menuItem.classList.remove(hoverClass);
                }, hideDelay);
            };

            menuItem.addEventListener('mouseenter', openMenu);
            menuItem.addEventListener('mouseleave', closeMenu);
            submenu.addEventListener('mouseenter', openMenu);
            submenu.addEventListener('mouseleave', closeMenu);
        };

        desktopNav.querySelectorAll(':scope > ul > li.submenu').forEach(menuItem => {
            bindHoverMenu(menuItem, '.level_2');

            menuItem.querySelectorAll('.level_2 > li.submenu').forEach(subItem => {
                bindHoverMenu(subItem, '.level_3');
            });
        });
    }
});
